<template>
  <div>
    <loading v-if="pageStatus === 'loading'"></loading>
    <div v-else-if="pageStatus === 'reservation-not-found'">
      <ReservationNotFound></ReservationNotFound>
    </div>
  </div>
</template>

<script>
import ReservationNotFound from "@/components/Chat/ReservationNotFound.vue";
import Requests from "@/services/Requests";

export default {
  name: "Pay",
  components: {
    ReservationNotFound,
  },
  data() {
    return {
      reservationId: this.$route.params.id,
      pageStatus: "loading",
    };
  },
  methods: {
    async pay() {
      const response = await Requests.Reservation.Pay({
        reservationId: this.reservationId,
      });
      if (response.message === "OK") {
        if (window.parent) {
          window.parent.postMessage(response.data, "*");
        } else {
          window.location.href = response.data;
        }
      } else if (
        response.exceptionMessage === "RESERVATION_ALREADY_COMPLETED"
      ) {
        this.$router.push({
          name: "track",
          params: { id: this.reservationId },
        });
      } else if (
        response.exceptionMessage === "RESERVATION_NOT_FOUND" ||
        response.exceptionMessage === "ORDER_ID_ALREADY_EXISTS"
      ) {
        this.pageStatus = "reservation-not-found";
      }
    },
  },
  mounted() {
    this.pay();
  },
};
</script>
